import type { StandardServicePageContent } from "~/content/servicePage";

export const FireDetectionInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd systemów wykrywania pożaru",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Zwykle co kwartał lub co rok",
      description:
        "Częstotliwość zależy od rodzaju systemu, producenta, instrukcji eksploatacji i charakteru obiektu. W praktyce obok przeglądów okresowych występują też częstsze czynności konserwacyjne.",
    },
    {
      label: "Ile kosztuje",
      value: "Najczęściej wycena indywidualna",
      description:
        "Koszt zależy od liczby elementów, stref, rodzaju centrali, integracji z innymi systemami oraz miasta. Mały obiekt z prostym układem wycenia się inaczej niż hotel, biuro albo magazyn z rozbudowanym SSP.",
    },
    {
      label: "Co obejmuje",
      value: "Centralę, czujki, sygnalizatory i dokumentację",
      description:
        "Kontrola obejmuje zwykle czujki dymu i ciepła, ręczne ostrzegacze pożarowe, sygnalizatory, zasilanie podstawowe i awaryjne oraz wpisy serwisowe potwierdzające stan instalacji.",
    },
    {
      label: "Kiedy działać wcześniej",
      value: "Po remoncie, fałszywych alarmach lub zapyleniu",
      description:
        "Dodatkowa kontrola ma sens po zmianach aranżacji, pracach pylących, uszkodzeniach mechanicznych albo serii alarmów technicznych. To częste sytuacje w biurach, halach i budynkach usługowych.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd systemów wykrywania pożaru",
  sections: [
    {
      title: "Na czym polega przegląd systemów wykrywania pożaru",
      paragraphs: [
        `Przegląd systemów wykrywania pożaru polega na sprawdzeniu, czy instalacja rzeczywiście wykryje zagrożenie i uruchomi alarm wtedy, gdy będzie to potrzebne. Sama obecność czujek i centrali nie wystarcza, jeśli elementy są zabrudzone, rozregulowane albo nie mają potwierdzonej sprawności.`,
        `W praktyce usługa może dotyczyć zarówno autonomicznych czujników, jak i rozbudowanych systemów SSP w budynkach usługowych, biurowych, hotelowych czy magazynowych. Celem jest potwierdzenie, że system reaguje odpowiednio wcześnie i ma aktualną dokumentację eksploatacyjną.`,
        `Po kontroli właściciel albo zarządca powinien wiedzieć, które elementy działają prawidłowo, jakie usterki wymagają usunięcia i czy system nadaje się do dalszej bezpiecznej eksploatacji.`,
      ],
    },
    {
      title: "Co obejmuje kontrola SSP, SAP i czujek pożarowych",
      paragraphs: [
        `Zakres przeglądu obejmuje zwykle centralę, czujki dymu i ciepła, ręczne ostrzegacze pożarowe, sygnalizatory oraz zasilanie podstawowe i awaryjne. W zależności od obiektu sprawdza się także podstawowe powiązania z innymi systemami bezpieczeństwa.`,
        `W dobrze wykonanej kontroli nie chodzi wyłącznie o uruchomienie alarmu testowego. Liczy się też wykrycie zabrudzonych czujek, słabnących akumulatorów, błędów komunikacji, nieaktualnych opisów stref albo usterek, które mogą prowadzić do fałszywych alarmów.`,
        `To szczególnie ważne w budynkach, gdzie system wykrywania pożaru współpracuje z ewakuacją, oddymianiem albo organizacją pracy całego obiektu. Tam jakość dokumentacji i serwisu ma bezpośredni wpływ na bezpieczeństwo użytkowników.`,
      ],
    },
    {
      title: "Konserwacja, dokumentacja i kiedy zlecić dodatkową kontrolę",
      paragraphs: [
        `Systemy wykrywania pożaru wymagają nie tylko przeglądów, ale też regularnej konserwacji. To właśnie ona pozwala utrzymać sprawność czujek, centrali, sygnalizatorów i zasilania rezerwowego między kolejnymi terminami okresowymi.`,
        `Dodatkową kontrolę warto zlecić po remontach, pracach pylących, zmianie układu pomieszczeń albo po serii alarmów technicznych. Takie sytuacje potrafią zmienić warunki pracy systemu i sprawić, że wcześniejsze ustawienia lub rozmieszczenie czujek przestają być wystarczające.`,
        `Po wizycie powinna zostać uporządkowana dokumentacja serwisowa. Dla zarządcy oznacza to jasną informację, co zostało sprawdzone, jakie usterki wykryto i które działania trzeba zaplanować w pierwszej kolejności.`,
      ],
    },
    {
      title: "Cena przeglądu systemów wykrywania pożaru",
      paragraphs: [
        `Cena przeglądu systemów wykrywania pożaru jest zwykle ustalana indywidualnie. Na wycenę wpływa liczba elementów, stref, typ centrali, zakres testów i to, czy obiekt wymaga również rozbudowanej dokumentacji oraz wpisów serwisowych.`,
        `Inaczej wycenia się niewielki obiekt z prostym układem czujek, a inaczej hotel, magazyn albo biurowiec z większą liczbą stref i integracji. W większych miastach ceny bywają wyższe także z powodu organizacji pracy obiektu i okien serwisowych poza godzinami funkcjonowania.`,
        `Przy porównywaniu ofert warto sprawdzić, czy cena obejmuje tylko przegląd, czy również testy funkcjonalne, dokumentację i wskazanie usterek do usunięcia. To właśnie zakres usługi najlepiej pokazuje, czy oferta ma realną wartość dla zarządcy obiektu.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu systemów wykrywania pożaru",
  scopeItems: [
    "Kontrola centrali SSP",
    "Test czujek dymu",
    "Test czujek ciepła",
    "Sprawdzenie ROP",
    "Kontrola sygnalizatorów",
    "Weryfikacja zasilania awaryjnego",
    "Ocena opisów stref i dokumentacji",
    "Protokół z przeglądu",
  ],
  seo: {
    title: "Przegląd systemów wykrywania pożaru: SSP, czujki, cena",
    description:
      "Przegląd systemów wykrywania pożaru dla biur, hoteli, magazynów i wspólnot. Sprawdź zakres kontroli SSP, czujek i centrali oraz to, od czego zależy cena serwisu.",
  },
};
